import React, {PropTypes} from 'react'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import ListSubjectsTableItem from './list-subjects-table-item'

const ListSubjectsTable = ({semSubjects, onSelectItem}) => (
  <Table condensed hover>
    <thead>
      <tr>
        <th colSpan="7">
          <kbd>
            Year:
            {' '}
            {semSubjects.getIn(['meta', 'year'])}
            {' '}
            Sem:
            {' '}
            {semSubjects.getIn(['meta', 'sem'])}
          </kbd>
        </th>
      </tr>
      <tr>
        <th width="7%">{' '}</th>
        <th width="15%">Subject Code</th>
        <th>Subject Description</th>
        <th width="6%" className="text-right">Lec Units</th>
        <th width="6%" className="text-right">Lab Units</th>
        <th width="6%" className="text-right">Total Units</th>
        <th width="15%">Pre / CoRequisites ; Standing</th>
      </tr>
    </thead>
    <tbody>
      {semSubjects &&
        semSubjects
        .get('subjects')
        .map(subject => (
          <ListSubjectsTableItem
            key={subject.get('id')}
            subject={subject}
            onSelectItem={onSelectItem}
          />
        ))}
    </tbody>
    <tfoot>
      <tr>
        <th colSpan="3" className="text-right">Sub Total:</th>
        <th className="text-right">
          {acc.formatNumber(semSubjects.getIn(['meta', 'total_lec']), 1)}
        </th>
        <th className="text-right">
          {acc.formatNumber(semSubjects.getIn(['meta', 'total_lab']), 1)}
        </th>
        <th className="text-right">
          {acc.formatNumber(semSubjects.getIn(['meta', 'total']), 1)}
        </th>
        <th>{' '}</th>
      </tr>
    </tfoot>
  </Table>
)

ListSubjectsTable.propTypes = {
  semSubjects: PropTypes.object,
  onSelectItem: PropTypes.func,
}

export default ListSubjectsTable



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/list-subjects-table.js